export default "__VITE_ASSET__BAVpEkfZ__"